import Amazon from "./amazon.png?url";
import Apc from "./apc.png?url";
import Asendia from "./asendia.png?url";
import AustraliaPost from "./australia-post.png?url";
import CanadaPost from "./canada-post.png?url";
import Dhl from "./dhl.png?url";
import EPostGlobal from "./epostglobal.png?url";
import EtaExpress from "./eta-express.png?url";
import Fedex from "./fedex.png?url";
import FirstMile from "./firstmile.png?url";
import GlobalE from "./globale.png?url";
import Gls from "./gls.png?url";
import LandmarkGlobal from "./landmark-global.png?url";
import Ups from "./official-ups.png?url";
import Omniparcel from "./omniparcel.png?url";
import OnTrac from "./ontrac.png?url";
import PassportGlobal from "./passport-global.png?url";
import RoyalMail from "./royalmail.png?url";
import Sendle from "./sendle.png?url";
import SpeeDee from "./spee-dee.png?url";
import Usps from "./usps.png?url";
import Veho from "./veho.png?url";

export function getCarrierLogoUrl(carrier: string): string {
  if (!carrier) {
    return "";
  }
  // TODO (jaden): use svg
  if (carrier.toLowerCase().includes("ups")) {
    return Ups;
  } else if (carrier.toLowerCase().includes("fedex")) {
    return Fedex;
  } else if (carrier.toLowerCase().includes("usps")) {
    return Usps;
  } else if (carrier.toLowerCase().includes("dhl")) {
    return Dhl;
  } else if (carrier.toLowerCase().includes("sendle")) {
    return Sendle;
  } else if (carrier.toLowerCase().includes("amazon")) {
    return Amazon;
  } else if (carrier.toLowerCase().includes("veho")) {
    return Veho;
  } else if (carrier.toLowerCase().includes("firstmile")) {
    return FirstMile;
  } else if (carrier.toLowerCase().includes("australia")) {
    return AustraliaPost;
  } else if (
    carrier.toLowerCase().includes("canada post") ||
    carrier.toLowerCase().includes("canadapost")
  ) {
    return CanadaPost;
  } else if (carrier.toLowerCase().includes("royal mail")) {
    return RoyalMail;
  } else if (carrier.toLowerCase().includes("apc")) {
    return Apc;
  } else if (carrier.toLowerCase().includes("omniparcel")) {
    return Omniparcel;
  } else if (
    carrier.toLowerCase().includes("gls") ||
    carrier.toLowerCase().includes("gso")
  ) {
    return Gls;
  } else if (carrier.toLowerCase().includes("asendia")) {
    return Asendia;
  } else if (carrier.toLowerCase().includes("spee")) {
    return SpeeDee;
  } else if (carrier.toLowerCase().includes("passport")) {
    return PassportGlobal;
  } else if (carrier.toLowerCase().includes("landmark")) {
    return LandmarkGlobal;
  } else if (carrier.toLowerCase().includes("eta express")) {
    return EtaExpress;
  } else if (carrier.toLowerCase().includes("epost")) {
    return EPostGlobal;
  } else if (carrier.toLowerCase().includes("ontrac")) {
    return OnTrac;
  } else if (carrier.toLowerCase().includes("globale")) {
    return GlobalE;
  }
  return "";
}
